module.exports = new __parcel__URL__("beetlejuice-winona-ryder.cbc6b059.gif").toString();